module.exports = __webpack_public_path__ + "img/button.fc00bf72.png";